// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3spcc","productName":"Table_productName__OBff-"};